import { type StatsigLayerName, useLayer } from '@coursera-web/statsig';

const LAYER_NAME: StatsigLayerName = 'revoke-access-and-limited-free-trial-layer';
const PARAM_NAME = 'revoke-and-limited-trial-variant';

type Variant = 'control' | 'revoke-access' | 'limited-free-trial' | 'revoke-and-limited-trial';

// https://console.statsig.com/2aQACzHI81tdbY41wEZm3H/layers/revoke-access-and-limited-free-trial-layer
export const useIsRevokeAccessEnabled = (): boolean => {
  const layer = useLayer(LAYER_NAME);
  const variant = layer.get(PARAM_NAME, 'control') as Variant;
  return variant === 'revoke-access' || variant === 'revoke-and-limited-trial';
};

// https://console.statsig.com/2aQACzHI81tdbY41wEZm3H/layers/revoke-access-and-limited-free-trial-layer
export const useIsLimitedFreeTrialEnabled = (): boolean => {
  const layer = useLayer(LAYER_NAME);
  const variant = layer.get(PARAM_NAME, 'control') as Variant;
  return variant === 'limited-free-trial' || variant === 'revoke-and-limited-trial';
};
